import React from "react";
import PropTypes from "prop-types";
import {
  Collapse,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Avatar,
  withStyles
} from "@material-ui/core";
import CloudUpload from "@material-ui/icons/CloudUpload";
import CloudDownload from "@material-ui/icons/CloudDownload";
import CallMerge from "@material-ui/icons/CallMerge";
import Build from "@material-ui/icons/Build";
import CheckCircle from "@material-ui/icons/CheckCircle";
import ExitToApp from "@material-ui/icons/ExitToApp";
import Map from "@material-ui/icons/Map";
import Mail from "@material-ui/icons/Mail";
import Home from "@material-ui/icons/Home";
import EditIcon from "@material-ui/icons/Edit";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import Releases from "@material-ui/icons/NotificationsActive";
import OpenInNew from "@mui/icons-material/OpenInNew";
import { organizationURLStyle } from "util/organization";
import { workareaURLStyle } from "util/workarea";

function getListItemStyle(isSelected) {
  return isSelected
    ? {
        transition: "all 0s",
        backgroundColor: "rgba(0, 0, 0, 0.2980392)",
        fontFamily: "Roboto"
      }
    : {
        color: "#B6C3CC",
        fontFamily: "Roboto"
      };
}
function getTextStyle(isSelected) {
  return isSelected
    ? {
        color: "white",
        transition: "all 0s"
      }
    : { color: "#96A9B6" };
}

function getIconStyle(isSelected) {
  return isSelected
    ? {
        fill: "#B60C0F",
        color: "white",
        transition: "all 0s"
      }
    : { color: "#96A9B6" };
}

const styles = {
  subheaderStyle: {
    fontFamily: "Roboto",
    color: "#F0F3F5",
    fontSize: "14px",
    fontWeight: 450
  }
};

class NavDrawer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ctdOpen: true,
      soloOpen: true,
      dataOpen: true,
      elabOpen: true,
      validationOpen: true
    };
  }

  handleExpandClick(item) {
    switch (item) {
      case "ctd":
        this.setState(prevState => ({ ctdOpen: !prevState.ctdOpen }));
        break;
      case "solo":
        this.setState(prevState => ({ soloOpen: !prevState.soloOpen }));
        break;
      case "data":
        this.setState(prevState => ({ dataOpen: !prevState.dataOpen }));
        break;
      case "elab":
        this.setState(prevState => ({ elabOpen: !prevState.elabOpen }));
        break;
      case "validation":
        this.setState(prevState => ({
          validationOpen: !prevState.validationOpen
        }));
        break;
      default:
    }
  }

  render() {
    const workarea = this.props.workarea
      ? workareaURLStyle(this.props.workarea)
      : null;
    const organization = this.props.organization
      ? organizationURLStyle(this.props.organization)
      : null;
    const { pathname } = this.props.location;
    const { push } = this.props.history;

    const workareaOptional = workarea === null ? "" : `workarea=${workarea}`;
    const organizationOptional =
      organization === null ? "" : `organization=${organization}`;
    let optionalParams = [workareaOptional, organizationOptional]
      .filter(val => val)
      .join("&");
    if (optionalParams.length) {
      optionalParams = `?${optionalParams}`;
    }
    const otherDevMode =
      this.props.mode === "development" ? "production" : "development";

    return (
      <Drawer
        open={this.props.appDrawerOpen}
        variant="persistent"
        anchor="left"
      >
        <List>
          <ListItem key="user" style={getListItemStyle(false)}>
            <Avatar src={this.props.userPhoto} />
            <ListItemText
              primary={this.props.username}
              disableTypography
              className={this.props.classes.subheaderStyle}
              style={{ paddingLeft: 15, maxWidth: 135 }}
            />
          </ListItem>
          <List>
            {this.props.mode === "development" && (
              <ListItem
                button
                style={getListItemStyle(false)}
                onClick={() => this.props.onChangeDevMode(otherDevMode)}
              >
                <ListItemIcon>
                  <Build style={getIconStyle(false)} />
                </ListItemIcon>
                <ListItemText
                  key="productionSwitch"
                  disableTypography
                  primary="Switch theme"
                  style={getTextStyle(false)}
                />
              </ListItem>
            )}
            <ListItem
              button
              key="home"
              onClick={() => push(`/portal2`)}
              style={getListItemStyle(pathname === "/portal2")}
            >
              <ListItemIcon>
                <Home style={getIconStyle(pathname === "/portal2")} />
              </ListItemIcon>
              <ListItemText
                primary="Home"
                disableTypography
                style={getTextStyle(pathname === "/portal2")}
              />
            </ListItem>
            <ListItem
              button
              key="release"
              onClick={() => push(`/portal2/releases`)}
              style={getListItemStyle(pathname === "/portal2/releases")}
            >
              <ListItemIcon>
                <Releases
                  style={getIconStyle(pathname === "/portal2/releases")}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary="Release Notes"
                style={getTextStyle(pathname === "/portal2/releases")}
              />
            </ListItem>
            <ListItem
              button
              key="workarea"
              style={getListItemStyle(pathname.includes("/portal2/workarea"))}
              onClick={this.props.onChangeWorkarea}
            >
              <ListItemIcon>
                <Map
                  style={getIconStyle(pathname.includes("/portal2/workarea"))}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary="Change Workarea"
                style={getTextStyle(pathname === "/portal2/workarea")}
              />
            </ListItem>
            <ListItem
              button
              key="organization"
              style={getListItemStyle(
                pathname.includes("/portal2/organization")
              )}
              onClick={this.props.onChangeOrganization}
            >
              <ListItemIcon>
                <Map
                  style={getIconStyle(
                    pathname.includes("/portal2/organization")
                  )}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary="Change Org."
                style={getTextStyle(pathname === "/portal2/organization")}
              />
            </ListItem>
            <ListItem
              button
              key="feature-request"
              onClick={() =>
                window.open(
                  "https://slack.com/app_redirect?channel=C03F37AUU01&team=T4J06A049"
                )
              }
              style={getListItemStyle(false)}
            >
              <ListItemIcon>
                <Mail style={getIconStyle(false)} />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary="Request a Feature"
                style={getTextStyle(false)}
              />
            </ListItem>
            <ListItem
              button
              key="logout"
              onClick={this.props.onLogout}
              style={getListItemStyle(false)}
            >
              <ListItemIcon>
                <ExitToApp style={getIconStyle(false)} />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                disableTypography
                style={getTextStyle(false)}
              />
            </ListItem>
          </List>
          <ListItem
            button
            key="ctd"
            onClick={() => this.handleExpandClick("ctd")}
            className={this.props.classes.subheaderStyle}
          >
            <ListItemText
              disableTypography
              className={this.props.classes.subheaderStyle}
              primary="CTD Tools"
            />
            {this.state.ctdOpen ? (
              <ExpandLess style={getIconStyle(false)} />
            ) : (
              <ExpandMore style={getIconStyle(false)} />
            )}
          </ListItem>
          <Collapse in={this.state.ctdOpen}>
            <ListItem
              button
              key="ctd-upload"
              onClick={() => push(`/portal2/ctd/upload${optionalParams}`)}
              style={getListItemStyle(pathname === "/portal2/ctd/upload")}
            >
              <ListItemIcon>
                <CloudUpload
                  style={getIconStyle(pathname === "/portal2/ctd/upload")}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary="Upload"
                style={getTextStyle(pathname === "/portal2/ctd/upload")}
              />
            </ListItem>
            <ListItem
              button
              key="ctd-annotate"
              style={getListItemStyle(pathname === "/portal2/ctd/annotate")}
              onClick={() => push(`/portal2/ctd/annotate${optionalParams}`)}
            >
              <ListItemIcon>
                <CallMerge
                  style={getIconStyle(pathname === "/portal2/ctd/annotate")}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary="Annotate"
                style={getTextStyle(pathname === "/portal2/ctd/annotate")}
              />
            </ListItem>
            <ListItem
              button
              key="ctd-status"
              style={getListItemStyle(pathname === "/portal2/ctd/status")}
              onClick={() => push(`/portal2/ctd/status${optionalParams}`)}
            >
              <ListItemIcon>
                <CheckCircle
                  style={getIconStyle(pathname === "/portal2/ctd/status")}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary="Processing Status"
                style={getTextStyle(pathname === "/portal2/ctd/status")}
              />
            </ListItem>
            <ListItem
              button
              key="ctd-download"
              style={getListItemStyle(pathname === "/portal2/ctd/download")}
              onClick={() => push(`/portal2/ctd/download${optionalParams}`)}
            >
              <ListItemIcon>
                <CloudDownload
                  style={getIconStyle(pathname === "/portal2/ctd/download")}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary="Download"
                style={getTextStyle(pathname === "/portal2/ctd/download")}
              />
            </ListItem>
          </Collapse>
          <ListItem
            button
            key="solo"
            onClick={() => this.handleExpandClick("solo")}
            className={this.props.classes.subheaderStyle}
          >
            <ListItemText
              disableTypography
              className={this.props.classes.subheaderStyle}
              primary="Solo Tools"
            />
            {this.state.soloOpen ? (
              <ExpandLess style={getIconStyle(false)} />
            ) : (
              <ExpandMore style={getIconStyle(false)} />
            )}
          </ListItem>
          <Collapse in={this.state.soloOpen}>
            <List>
              <ListItem
                button
                key="solo-upload"
                style={getListItemStyle(pathname === "/portal2/solo/upload")}
                onClick={() => push(`/portal2/solo/upload${optionalParams}`)}
              >
                <ListItemIcon>
                  <CloudUpload
                    style={getIconStyle(pathname === "/portal2/solo/upload")}
                  />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary="Upload"
                  style={getTextStyle(pathname === "/portal2/solo/upload")}
                />
              </ListItem>
              <ListItem
                button
                key="solo-annotate"
                style={getListItemStyle(pathname === "/portal2/solo/annotate")}
                onClick={() => push(`/portal2/solo/annotate${optionalParams}`)}
              >
                <ListItemIcon>
                  <CallMerge
                    style={getIconStyle(pathname === "/portal2/solo/annotate")}
                  />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary="Annotate"
                  style={getTextStyle(pathname === "/portal2/solo/annotate")}
                />
              </ListItem>
              <ListItem
                button
                key="solo-confirm"
                style={getListItemStyle(pathname === "/portal2/solo/confirm")}
                onClick={() => push(`/portal2/solo/confirm${optionalParams}`)}
              >
                <ListItemIcon>
                  <CheckCircle
                    style={getIconStyle(pathname === "/portal2/solo/confirm")}
                  />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary="Confirm"
                  style={getTextStyle(pathname === "/portal2/solo/confirm")}
                />
              </ListItem>
            </List>
          </Collapse>
          <ListItem
            button
            key="data"
            onClick={() => this.handleExpandClick("data")}
            className={this.props.classes.subheaderStyle}
          >
            <ListItemText
              disableTypography
              className={this.props.classes.subheaderStyle}
              primary="Data Tools"
            />
            {this.state.dataOpen ? (
              <ExpandLess style={getIconStyle(false)} />
            ) : (
              <ExpandMore style={getIconStyle(false)} />
            )}
          </ListItem>
          <Collapse in={this.state.dataOpen}>
            <List>
              <ListItem
                button
                key="datatools-status"
                style={getListItemStyle(pathname === "/portal2/status")}
                onClick={() => push(`/portal2/status`)}
              >
                <ListItemIcon>
                  <CheckCircle
                    style={getIconStyle(pathname === "/portal2/status")}
                  />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary="Submission Status"
                  style={getTextStyle(pathname === "/portal2/status")}
                />
              </ListItem>
              <ListItem
                button
                key="datatools-download"
                style={getListItemStyle(pathname === "/portal2/download")}
                onClick={() => push(`/portal2/download`)}
              >
                <ListItemIcon>
                  <CloudDownload
                    style={getIconStyle(pathname === "/portal2/download")}
                  />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary="Download"
                  style={getTextStyle(pathname === "/portal2/download")}
                />
              </ListItem>
              <ListItem
                button
                key="datatools-upload"
                style={getListItemStyle(pathname === "/portal2/upload")}
                onClick={() => push(`/portal2/upload${optionalParams}`)}
              >
                <ListItemIcon>
                  <CloudUpload
                    style={getIconStyle(pathname === "/portal2/upload")}
                  />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary="Upload"
                  style={getTextStyle(pathname === "/portal2/upload")}
                />
              </ListItem>
              {this.props.adminAccess && (
                <ListItem
                  button
                  key="datatools-json-editor"
                  onClick={() => push(`/portal2/edit-form${optionalParams}`)}
                >
                  <ListItemIcon>
                    <EditIcon
                      style={getIconStyle(pathname === "/portal2/edit-form")}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Edit Forms"
                    style={getTextStyle(pathname === "/portal2/edit-form")}
                  />
                </ListItem>
              )}
            </List>
          </Collapse>
          <ListItem
            button
            key="elab"
            onClick={() => this.handleExpandClick("elab")}
            className={this.props.classes.subheaderStyle}
          >
            <ListItemText
              disableTypography
              className={this.props.classes.subheaderStyle}
              primary="eLAB Tools"
            />
            {this.state.elabOpen ? (
              <ExpandLess style={getIconStyle(false)} />
            ) : (
              <ExpandMore style={getIconStyle(false)} />
            )}
          </ListItem>
          <Collapse in={this.state.elabOpen}>
            <List>
              <ListItem
                button
                key="elab-upload"
                style={getListItemStyle(pathname === "/portal2/elabupload")}
                onClick={() => push(`/portal2/elabupload`)}
              >
                <ListItemIcon>
                  <CloudUpload
                    style={getIconStyle(pathname === "/portal2/elabupload")}
                  />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary="Bulk Upload"
                  style={getTextStyle(pathname === "/portal2/elabupload")}
                />
              </ListItem>
            </List>
          </Collapse>

          {this.props.allowedAccess ? (
            <ListItem
              button
              key="validation"
              onClick={() => this.handleExpandClick("validation")}
              className={this.props.classes.subheaderStyle}
            >
              <ListItemText
                disableTypography
                className={this.props.classes.subheaderStyle}
                primary="Validation"
              />
              {this.state.validationOpen ? (
                <ExpandLess style={getIconStyle(false)} />
              ) : (
                <ExpandMore style={getIconStyle(false)} />
              )}
            </ListItem>
          ) : (
            <ListItem></ListItem>
          )}
          {this.props.allowedAccess && (
            <Collapse in={this.state.validationOpen}>
              <List>
                <ListItem
                  button
                  key="sample-validator"
                  style={getListItemStyle(
                    pathname ===
                      "/qc/oceanography/src/sample-validator/runqa.html"
                  )}
                  component="a"
                  href="/qc/oceanography/src/sample-validator/runqa.html"
                >
                  <ListItemIcon>
                    <OpenInNew
                      style={getIconStyle(
                        pathname ===
                          "/qc/oceanography/src/sample-validator/runqa.html"
                      )}
                    />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary="Sample Validator"
                    style={getTextStyle(
                      pathname ===
                        "/qc/oceanography/src/sample-validator/runqa.html"
                    )}
                  />
                </ListItem>
                <ListItem
                  button
                  key="matrix-viewer"
                  style={getListItemStyle(
                    pathname === "/qc/oceanography/src/matrix-viewer/index.html"
                  )}
                  component="a"
                  href="/qc/oceanography/src/matrix-viewer/index.html"
                >
                  <ListItemIcon>
                    <OpenInNew
                      style={getIconStyle(
                        pathname ===
                          "/qc/oceanography/src/matrix-viewer/index.html"
                      )}
                    />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary="Matrix Viewer"
                    style={getTextStyle(
                      pathname ===
                        "/qc/oceanography/src/matrix-viewer/index.html"
                    )}
                  />
                </ListItem>
                <ListItem
                  button
                  key="historical-matrix"
                  style={getListItemStyle(
                    pathname ===
                      "/qc/oceanography/src/matrix-viewer/historicalmatrix.html"
                  )}
                  component="a"
                  href="/qc/oceanography/src/matrix-viewer/historicalmatrix.html"
                >
                  <ListItemIcon>
                    <OpenInNew
                      style={getIconStyle(
                        pathname ===
                          "/qc/oceanography/src/matrix-viewer/historicalmatrix.html"
                      )}
                    />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary="Historical Matrix"
                    style={getTextStyle(
                      pathname ===
                        "/qc/oceanography/src/matrix-viewer/historicalmatrix.html"
                    )}
                  />
                </ListItem>
              </List>
            </Collapse>
          )}
        </List>
      </Drawer>
    );
  }
}

NavDrawer.propTypes = {
  classes: PropTypes.shape({
    subheaderStyle: PropTypes.string.isRequired
  }).isRequired,
  mode: PropTypes.string.isRequired,
  appDrawerOpen: PropTypes.bool.isRequired,
  onChangeDevMode: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  onChangeWorkarea: PropTypes.func.isRequired,
  onChangeOrganization: PropTypes.func.isRequired,
  userPhoto: PropTypes.string,
  username: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    query: PropTypes.shape({
      workarea: PropTypes.string,
      organization: PropTypes.string
    })
  }).isRequired,
  workarea: PropTypes.string,
  organization: PropTypes.string,
  allowedAccess: PropTypes.bool.isRequired,
  adminAccess: PropTypes.bool.isRequired
};

NavDrawer.defaultProps = {
  workarea: "",
  organization: "",
  userPhoto: "",
  username: ""
};

// NavDrawer.shouldComponentUpdate = () => false;
export default withStyles(styles)(NavDrawer);
